import { render, staticRenderFns } from "./RevisionCardSkeletonLoader.vue?vue&type=template&id=bb2cb4f6&scoped=true&"
import script from "./RevisionCardSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./RevisionCardSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./RevisionCardSkeletonLoader.vue?vue&type=style&index=0&id=bb2cb4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2cb4f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardActions,VCardTitle,VDivider,VSkeletonLoader})
